/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import queryString from "query-string"

// other
// import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Collapse, Container, Row } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"

import dayjs from "dayjs"
import { useHistory, useLocation } from "react-router-dom"
import AlertComponent from "../../../components/AlertComponent"

import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"

import {
  TSyaryoSyozokuListGetReq,
  TSyaryoSyozokuInfoGetRes,
} from "../../../service/truck/syaryoSyozoku/TSyaryoSyozoku"
import SyaryoSyozokuService from "../../../service/truck/syaryoSyozoku/syaryoSyozokuService"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import { useDispatch, useSelector } from "react-redux"

import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import { TWijmoComboBox } from "../../../type/wijmoComponents"

import ComboBox from "../../../components/ComboBox"
import { AppDispatch } from "../../.."
import { clearAlert, setWarningAlerts } from "../../../globalStore/alertStore"
import { 画面ロック解除 } from "../../../globalStore/progressStore"
import IdoRegisterModal from "./IdoRegisterModal"
import TantoChangeModal from "./TantoChangeModal"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import BusyoService from "../../../service/master/busyo/busyoService"
import { Form } from "react-bootstrap"
import commonUtil from "../../../ts/util/commonUtil"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import { RootState } from "../../../globalStore/rootreducer"
import { FunctionContext } from "../../../components/Context"
import kengenUtil from "../../../ts/util/kengenUtil"

// #region [type]
// DefaultCombo
export type TItem = { name: string; value: any }
//#endregion

/**
 * 車輌所属マスタ
 */
const SyaryoSyozokuMaster = () => {
  const history = useHistory()
  const location = useLocation()
  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)
  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "SyaryoSyozokuMaster_GridId"

  // 権限制御
  const userInfo = useSelector(
    (rootState: RootState) => rootState.user.LoginUserInfo
  )
  const 読取専用フラグ = kengenUtil.車輌異動ボタンの権限判定(userInfo)

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TSyaryoSyozokuInfoGetRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        sort_車番: (i: TSyaryoSyozokuInfoGetRes) =>
          commonUtil.createSortString(i.車番, VALIDATE_CONSTANT.LENGTH.車番),
      },

      sortDescriptions: [new wjCore.SortDescription("sort_車番", true)],

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TSyaryoSyozokuListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) //Alertクリア

    let currentSearchCondition: TSyaryoSyozokuListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }

    if (currentSearchCondition == null) return
    setPreSearchCondition({ ...currentSearchCondition })

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new SyaryoSyozokuService().getList(
        currentSearchCondition
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      // dispatch(setAlerts(error))
      dispatch(setWarningAlerts(["エラー表示"]))
    } finally {
      setIsSearching(false) // 検索状態切り替え
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TSyaryoSyozokuListGetReq = queryString.parse(location.search)
    set部所コード(query.部所コード)
    set車番(query.車番)
    set乗務員氏名(query.乗務員氏名)
    set原動機フラグ(
      query.原動機有無フラグ != null ? query.原動機有無フラグ.toString() : null
    )

    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyaryoSyozokuListGetReq => {
    return {
      部所コード: 部所コード ?? undefined,
      車番: 車番 ?? undefined,
      乗務員氏名: 乗務員氏名 ?? undefined,
      原動機有無フラグ:
        原動機フラグ != null && !wjCore.isNullOrWhiteSpace(原動機フラグ)
          ? parseInt(原動機フラグ)
          : undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TSyaryoSyozokuListGetReq
  ) => {
    const disp部所 = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.部所コード
    )
    return {
      部所: disp部所
        ? `${disp部所.部所コード} ${disp部所.部所略称}`
        : undefined,
      車番,
      乗務員氏名,
      原動機: boolList?.find(
        (i) => i.value === searchCondition.原動機有無フラグ?.toString()
      )?.name,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    var extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    // ループをフラグで制御？
    if (ref明細フォーマットフラグ.current) return
    var columnHeaders = f.columnHeaders

    columnHeaders.columns.forEach((c, index) => {
      // 固定部分
      if (c.binding?.includes("現在_")) {
        columnHeaders.setCellData(0, index, "現在の所属部所")
      } else if (c.binding?.includes("異動先_")) {
        columnHeaders.setCellData(0, index, "異動先の部所")
      } else {
        const setHeaderText = c.header ?? ""
        columnHeaders.setCellData(0, index, setHeaderText)
      }

      c.allowMerging = true
    })

    // フォーマットのループ制御
    ref明細フォーマットフラグ.current = true
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()
  // モーダル側との検索動作判定用
  const [preSearchCondition, setPreSearchCondition] =
    useState<TSyaryoSyozokuListGetReq>({} as TSyaryoSyozokuListGetReq)

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //modal
  const [isSyozokuModalShow, setIsSyozokuModalShow] = useState<boolean>(false)
  const [isTantoChangeModalShow, setIsTantoChangeModalShow] =
    useState<boolean>(false)

  //#endregion

  //#region [state]

  // ComboBoxState
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  // 原動機
  const [原動機ComboBox, set原動機ComboBox] = useState<TWijmoComboBox<
    number,
    TItem
  > | null>(null)
  const [原動機IsLoadEnded, set原動機IsLoadEnded] = useState<boolean>(false)
  const [原動機ItemSource, set原動機ItemSource] = useState<TItem[]>()

  // 設定
  const [車輌所属ID, set車輌所属ID] = useState<number>()
  const [車輌ID, set車輌ID] = useState<number>()

  const [部所コード, set部所コード] = useState<string | null>()
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  const [車番, set車番] = useState<string | null>()
  const [乗務員氏名, set乗務員氏名] = useState<string | null>()

  const [原動機フラグ, set原動機フラグ] = useState<string | null>(null)

  //#endregion

  //#region [effect]

  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      set原動機ItemSource(boolList)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `車輌所属マスタ一覧`
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">車輌所属マスタ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>

            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <ComboBox.Busyo
                              placeholder="部所"
                              autoFocus
                              isAllSelect={true}
                              itemsSource={部所ItemSource}
                              isLoadEnded={部所IsLoadEnded}
                              setIsLoadEnded={set部所IsLoadEnded}
                              setSelectedValue={set部所コード}
                              selectedValue={部所コード}
                              setSelectedItem={set部所}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            <ComboBox.Default
                              className="max-w-10rem"
                              placeholder="原動機"
                              isAllSelect={true}
                              itemsSource={原動機ItemSource}
                              selectedValue={原動機フラグ}
                              setSelectedValue={set原動機フラグ}
                              isLoadEnded={原動機IsLoadEnded}
                              setIsLoadEnded={set原動機IsLoadEnded}
                              ComboBox={原動機ComboBox}
                              setComboBox={
                                set原動機ComboBox
                              }></ComboBox.Default>
                            <div className="input-group">
                              <div className="w-4rem">
                                <TextInput
                                  id="車番"
                                  name="車番"
                                  value={車番 ?? ""}
                                  setValue={set車番}
                                  maxLength={4}
                                  placeholder="車番"
                                />
                              </div>
                              <div className="w-15rem">
                                <TextInput
                                  id="乗務員氏名"
                                  name="乗務員氏名"
                                  value={乗務員氏名 ?? ""}
                                  setValue={set乗務員氏名}
                                  placeholder="乗務員氏名"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>

      <FunctionContext.Provider
        value={() => {
          search(preSearchCondition)
        }}>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  searchConditionClear={searchConditionClear}
                  gridId={gridId}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  gridProperties={{
                    // allowSorting: wjGrid.AllowSorting.None,
                    allowDragging: wjGrid.AllowDragging.None,
                  }}>
                  {!読取専用フラグ && (
                    <wjrGrid.FlexGridColumn
                      header=" "
                      align="center"
                      width={90}
                      selectable={false}
                      isReadOnly>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TSyaryoSyozokuInfoGetRes>
                        ) => {
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              onClick={() => {
                                // 画面全体のスクロール位置の保存
                                gridPageHelper.savePageConditionData(
                                  location.pathname
                                )
                                // 異動先のID情報をStateでModalに渡す。
                                set車輌所属ID(context.item.異動先_車輌所属ID)
                                set車輌ID(context.item.車輌ID)
                                setIsSyozokuModalShow(true)
                              }}>
                              異動登録
                            </Button>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                  )}
                  <wjrGrid.FlexGridColumn
                    header=" "
                    align="center"
                    width={90}
                    selectable={false}
                    isReadOnly>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TSyaryoSyozokuInfoGetRes>
                      ) => {
                        return (
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            onClick={() => {
                              // 画面全体のスクロール位置の保存
                              gridPageHelper.savePageConditionData(
                                location.pathname
                              )
                              // 異動先のID情報をStateでModalに渡す。
                              set車輌所属ID(context.item.異動先_車輌所属ID)
                              set車輌ID(context.item.車輌ID)
                              setIsTantoChangeModalShow(true)
                            }}>
                            担当変更
                          </Button>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="車番"
                    width={80}
                    sortMemberPath="sort_車番"
                    header="車番"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="車輌ID"
                    width={80}
                    header="車輌ID">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TSyaryoSyozokuInfoGetRes>
                      ) => {
                        let displayItem
                        if (
                          context.item.車輌ID != null ||
                          context.item.車輌ID < 0
                        ) {
                          displayItem = ""
                        }
                        displayItem = context.item.車輌ID.toString()
                        return <div className="text-end">{displayItem}</div>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>

                  <wjrGrid.FlexGridColumn
                    binding="登録番号"
                    width={130}
                    header="登録番号"></wjrGrid.FlexGridColumn>

                  <wjrGrid.FlexGridColumn
                    binding="原動機有無フラグ"
                    width={80}
                    align="left"
                    header="原動">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TSyaryoSyozokuInfoGetRes>
                      ) => {
                        let displayItem = ""
                        if (context.item.原動機有無フラグ === 1) {
                          displayItem = "有"
                        }
                        return <>{displayItem}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="車種区分名称1"
                    width={200}
                    header="車種"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="現在_所属開始日"
                    width={110}
                    header="所属開始日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TSyaryoSyozokuInfoGetRes>
                      ) => {
                        let dt = ""
                        if (context.item.現在_所属開始日)
                          dt = dayjs(context.item.現在_所属開始日).format(
                            "YYYY/MM/DD"
                          )
                        return <>{dt}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="現在_部所名"
                    width={200}
                    header="部所名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="現在_社員名"
                    width={128}
                    header="担当乗務員"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="現在_備考"
                    width={200}
                    header="備考"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="現在_表示順"
                    width={80}
                    header="表示順"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="異動先_所属開始日"
                    width={110}
                    header="異動日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TSyaryoSyozokuInfoGetRes>
                      ) => {
                        let dt = ""
                        if (context.item.異動先_所属開始日)
                          dt = dayjs(context.item.異動先_所属開始日).format(
                            "YYYY/MM/DD"
                          )
                        return <>{dt}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="異動先_部所名"
                    width={200}
                    header="部所名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="異動先_社員名"
                    width={128}
                    header="担当乗務員"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="異動先_備考"
                    width={200}
                    header="備考"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <IdoRegisterModal
          isShow={isSyozokuModalShow}
          setIsShow={(v) => {
            setIsSyozokuModalShow(v)
          }}
          車輌ID={車輌ID!}
          登録更新={車輌所属ID ? "更新" : "登録"}></IdoRegisterModal>
        <TantoChangeModal
          isShow={isTantoChangeModalShow}
          setIsShow={(v) => {
            setIsTantoChangeModalShow(v)
          }}
          車輌ID={車輌ID!}></TantoChangeModal>
      </FunctionContext.Provider>
    </Container>
  )
}

export default SyaryoSyozokuMaster

// defaultComboBox用
const boolList: TItem[] = [
  {
    name: "なし",
    value: "0",
  },
  {
    name: "あり",
    value: "1",
  },
]
